<template>
  <div :class="$store.state.theme">
    <Intro />
  </div>
</template>

<script>
import Intro from '../components/Intro.vue';

export default {
  name: 'Home',
  components: {
    Intro,
  },
};
</script>

<style scoped>
.light {
  background-color: #f0f8ff;
  color: #2c3e50;
}
.dark {
  background-color: #2c3e50;
  color: #ecf0f1;
}
button {
  margin: 10px;
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
button:hover {
  background-color: #0056b3;
}
</style>